<template>
  <app-list
    :goToSingleItem="goToSingleItem"
    :items="filteredItems"
    :loading="convertersIsLoading"
    :error="convertersError"
    cardsWithImage
    cardImageFieldName="image_thumbnail"
    :pageNumber="pageNumber"
    :updatePageNumber="SET_PAGE_NUMBER"
    :displayMenu=true
  >
    <template v-slot:action-buttons>
      <v-btn
        :to="{ name:'add-converter' }"
        class="text-none"
      >
        <v-icon class="mr-2">mdi-plus</v-icon>
        Add a Catalytic Converter
      </v-btn>
    </template>
    <template v-slot:search-box>
      <v-text-field
        placeholder="Search"
        class="catalytic-converter-list_search white"
        v-model.lazy="search"
        append-icon="mdi-magnify"
        hide-details
        outlined
        dense
      />
    </template>

    <template v-slot:menu-options="{ item }">
      <v-list-item
        @click="$router.push({name:'edit-converter', params: {id:item.id}})"
        dense
      >
        <v-list-item-title>Edit</v-list-item-title>
      </v-list-item>
      <v-divider />
      <v-list-item
        @click="deleteClicked(item.id, item.code)"
        dense
      >
        <v-list-item-title class="red--text">Delete</v-list-item-title>
      </v-list-item>
    </template>
    <template v-slot:app-item="{ item }">
      <span class="pb-2 font-weight-black text-h6">{{ item.code }}</span>
      <span class="pb-2 text-body-1 black--text">Manufacturer: {{ item.manufacturer }}</span>
      <span v-if="item.description" class="pb-2 text-body-1 black--text">Description: {{ item.description }}</span>
      <!-- <span
        v-if="item.current_price"
        class="pb-2 text-body-1 font-weight-bold black--text"
      >${{ item.current_price }} </span> -->
    </template>
  </app-list>
</template>

<script>
import { mapActions, mapState, mapMutations } from "@/store/modules/catalyticConverters";
import AppList from "@/components/AppList.vue";

export default {
  created() {
    if (!this.convertersAreFetchedOnce) {
      this.fetchConverters();
    }
  },
  data() {
    return {
      search: "",
    };
  },
  components: {
    AppList,
  },
  methods: {
    ...mapActions({
      fetchConverters: "fetch",
      deleteConverter: "delete",
    }),
    ...mapMutations(['SET_PAGE_NUMBER']),
    deleteClicked(converterId, converterCode) {
      if (window.confirm(`Are you sure that you want to delete ${converterCode}?`)) {
        this.deleteConverter(converterId);
      }
    },
    goToSingleItem(converterId) {
      this.$router.push({name:'single-converter', params: {id: converterId}});
    },
  },
  computed: {
    ...mapState({
      converters: (state) => state.data,
      convertersIsLoading: (state) => state.isLoading,
      convertersError: (state) => state.error,
      converterIsBeingDeletedId: (state) => state.isBeingDeletedId,
      convertersAreFetchedOnce: (state) => state.isFetchedOnce,
      pageNumber: state => state.pageNumber
    }),
    filteredItems() {
      const _self = this;
      if (this.search) {
        const filteredItems = this.converters.filter(function (item) {
          const searchableValues = [item.code, item.manufacturer];
          const result = searchableValues.find((dataPoint) => {
            if (dataPoint) {
              return dataPoint.toString().toLowerCase().includes(_self.search.toLowerCase());
            }
            return false;
          });
          return result;
        });
        return filteredItems;
      }
      return this.converters;
    },
  },
};
</script>

<style scoped>
.catalytic-converter-list_search {
  width: 300px;
  justify-self: end;
}
</style>
